document.addEventListener('DOMContentLoaded', function () {
  const variantRadios = document.querySelectorAll('.variant-radio');
  const addToCartButtons = document.querySelectorAll('.button--addtocart');
  const variantIdInput = document.getElementById('variant-id');

  // Function to get the selected variant ID based on selected options
  function getSelectedVariantId() {
    const selectedOptions = {};

    // Get the selected options (e.g., Size, Color, etc.)
    const selectedRadios = document.querySelectorAll('.variant-radio:checked');

    selectedRadios.forEach(radio => {
      const optionName = radio.getAttribute('data-option');
      const value = radio.value;
      selectedOptions[optionName] = value;
    });

    // Find the variant that matches the selected options
    const selectedVariant = window.variantData.variants.find(variant => {
      return variant.options.every((option, index) => {
        return option === selectedOptions[Object.keys(selectedOptions)[index]];
      });
    });

    return selectedVariant ? selectedVariant.id : window.variantData.variants[0].id;
  }

  // Function to update variant details (name and price) in all buttons
  function updateVariantDetails(variantId) {
    const selectedVariant = window.variantData.variants.find(variant => variant.id == variantId);

    if (selectedVariant) {
      addToCartButtons.forEach(button => {
        const variantNameSpan = button.querySelector('.variant-name');
        const variantPriceSpan = button.querySelector('.variant-price');

        if (variantNameSpan) {
          variantNameSpan.textContent = selectedVariant.title;
        }
        if (variantPriceSpan) {
          variantPriceSpan.textContent = selectedVariant.price;
        }
      });
    }
  }

  // Initialize the Add to Cart buttons with the default selected variant
  const initialVariantId = window.variantData.variants[0].id;
  updateVariantDetails(initialVariantId);

  // Add event listeners to the variant radio buttons
  variantRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      const selectedVariantId = getSelectedVariantId();
      updateVariantDetails(selectedVariantId);

      // Update the hidden variant ID input field
      variantIdInput.value = selectedVariantId;
    });
  });
});
